export default __webpack_public_path__ + "static/media/shopping-cart.888f440f.svg";